import "./IngredientsTab.css";

function IngredientsTab({ food }) {

    const ingredients = food.ingredients || [];

    const allergens = food.allergens || [];

    const tags = food.tags || [];

    return (

        <div className="ingredients-tab">

            <div className="ingredients-grid">

                <div className="ingredients-card">

                    <h2>Ingredients</h2>

                    {ingredients.length > 0 ? (

                        <ul>

                            {ingredients.map((item, index) => (

                                <li key={index}>

                                    ✅ {item}

                                </li>

                            ))}

                        </ul>

                    ) : (

                        <p>No ingredients available.</p>

                    )}

                </div>

                <div className="ingredients-card">

                    <h2>Allergens</h2>

                    {allergens.length > 0 ? (

                        <ul>

                            {allergens.map((item, index) => (

                                <li key={index}>

                                    ⚠️ {item}

                                </li>

                            ))}

                        </ul>

                    ) : (

                        <p>No allergens available.</p>

                    )}

                </div>

            </div>

            <div className="ingredients-card tags-card">

                <h2>Tags</h2>

                <div className="tag-container">

                    {tags.length > 0 ? (

                        tags.map((tag, index) => (

                            <span
                                key={index}
                                className="food-tag"
                            >
                                {tag}
                            </span>

                        ))

                    ) : (

                        <p>No tags available.</p>

                    )}

                </div>

            </div>

        </div>

    );

}

export default IngredientsTab;